import {
  NetworkIdSchema
} from "./chunk-RDCLQVKW.mjs";

// src/cards/announcementBanner.ts
import z from "zod";
var ProductBannerTheme = z.enum([
  "blue",
  "green",
  "purple",
  "pink",
  "black"
]);
var AnnouncementBannerSchema = z.object({
  id: z.string(),
  networkId: NetworkIdSchema.optional(),
  title: z.string(),
  description: z.string(),
  primaryCta: z.object({
    url: z.string(),
    label: z.string()
  }).optional(),
  secondaryCta: z.object({
    url: z.string(),
    label: z.string()
  }).optional(),
  publishedAt: z.string().datetime(),
  imageUrl: z.string().url().optional(),
  backgroundColor: z.string().optional()
});

export {
  ProductBannerTheme,
  AnnouncementBannerSchema
};
//# sourceMappingURL=chunk-B2QOLFWX.mjs.map